<template>
    <section class="footer non-printable">
        <div class="footer-base">
            <div class="container">
                <div class="col-md-6">
                    <ul class="footer-nav">
                        <li class="footer-nav-item">
                            <a href="mailto:VirtualConference@EFGHERMES.com"
                                >Contact us</a
                            >
                        </li>
                        <li class="footer-nav-item">
                            <a href="/privacy-policy"
                                >Privacy Policy</a
                            >
                        </li>
                    </ul>
                </div>

                <div class="col-md-6 align-right">
                    <ul class="socials-nav align-right">
                        <li class="socials-nav-item">
                            <a href="https://twitter.com/efghermes"
                                ><span class="fa fa-twitter"></span
                            ></a>
                        </li>
                        <li class="socials-nav-item">
                            <a
                                href="http://www.youtube.com/user/EFGHermesHolding"
                                ><span class="fa fa-youtube"></span
                            ></a>
                        </li>
                        <li class="socials-nav-item">
                            <a href="http://www.facebook.com/EFGHermes"
                                ><span class="fa fa-facebook"></span
                            ></a>
                        </li>
                        <li class="socials-nav-item">
                            <a
                                href="https://www.linkedin.com/company/efg-hermes"
                                ><span class="fa fa-linkedin"></span
                            ></a>
                        </li>
                    </ul>
                    <p class="text-alt">
                        <small>All Rights Reserved © 2021</small>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
export default {
    name: "Footer"
};
</script>

<style scoped>
 @media print {
     .non-printable {
         display: none;
     }
 }
</style>
